<template>
  <div class="container-fluid p-0">
    <div class="row no-gutters">
      <div class="col-xl-9">
        <div class="auth-full-bg pt-lg-5 p-4">
          <div class="w-100">
            <div class="bg-overlay"></div>
            <div class="d-flex h-100 flex-column">
              <div class="p-4 mt-auto">
                <div class="row justify-content-center">
                  <div class="col-lg-7">
                    <div class="text-center">
                      <h4 class="mb-3">
                        <i class="bx bxs-quote-alt-left text-primary h1 align-middle mr-3"></i
                        ><span class="text-primary">5k</span>+ Satisfied clients
                      </h4>

                      <div dir="ltr" class="owl-theme">
                        <Carousel
                          ref="carousel"
                          class="navs-carousel auth-review-carousel owl-theme"
                          id="timeline-carousel"
                          :navigation-enabled="false"
                          :pagination-active-color="'#556ee6'"
                          :pagination-color="'#556ee640'"
                          :pagination-position="'2'"
                          :pagination-padding="8"
                          :perPageCustom="[
                            [480, 1],
                            [768, 1],
                          ]"
                        >
                          <Slide>
                            <div class="item">
                              <div class="py-3">
                                <p class="font-size-16 mb-4">
                                  " Fantastic theme with a ton of options. If you just want the HTML to integrate with
                                  your project, then this is the package. You can find the files in the 'dist'
                                  folder...no need to install git and all the other stuff the documentation talks about.
                                  "
                                </p>

                                <div>
                                  <h4 class="font-size-16 text-primary">
                                    Abs1981
                                  </h4>
                                  <p class="font-size-14 mb-0">
                                    - Skote User
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Slide>

                          <Slide>
                            <div class="item">
                              <div class="py-3">
                                <p class="font-size-16 mb-4">
                                  " If Every Vendor on Envato are as supportive as Themesbrand, Development with be a
                                  nice experience. You guys are Wonderful. Keep us the good work. "
                                </p>

                                <div>
                                  <h4 class="font-size-16 text-primary">
                                    nezerious
                                  </h4>
                                  <p class="font-size-14 mb-0">
                                    - Skote User
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Slide>
                        </Carousel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->

      <div class="col-xl-3">
        <div class="auth-full-page-content p-md-5 p-4">
          <div class="w-100">
            <div class="d-flex flex-column h-100">
              <div class="mb-4 mb-md-5">
                <router-link to="/" class="d-block auth-logo">
                  <img src="@/assets/images/logo-dark.png" alt="" height="18" class="auth-logo-dark" />
                  <img src="@/assets/images/logo-light.png" alt="" height="18" class="auth-logo-light" />
                </router-link>
              </div>
              <div class="my-auto">
                <div>
                  <h5 class="text-primary">Welcome Back !</h5>
                  <p class="text-muted">Sign in to continue to Rental Beyond</p>
                </div>

                <div class="mt-4">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <b-alert v-if="errors" dismissible show variant="danger">{{ errors[0] }}</b-alert>

                    <b-form @submit.prevent="handleSubmit(onLogin)">
                      <b-form-group label="Email" label-for="email">
                        <ValidationProvider rules="email|required" v-slot="{ errors }">
                          <b-form-input id="email" v-model="credentials.email" placeholder="Enter email"></b-form-input>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                      </b-form-group>

                      <b-form-group label="Password" label-for="password">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                          <b-form-input
                            id="password"
                            v-model="credentials.password"
                            type="password"
                            placeholder="Enter password"
                          ></b-form-input>

                          <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                      </b-form-group>

                      <div class="custom-control custom-checkbox">
                        <input id="remember" type="checkbox" class="custom-control-input" />
                        <label class="custom-control-label" for="remember">Remember me</label>
                      </div>

                      <div class="mt-3">
                        <b-button type="submit" variant="primary" class="btn-block">Log In</b-button>
                      </div>

                      <div class="mt-4 text-center">
                        <router-link tag="a" to="/forgot-password" class="text-muted">
                          <i class="mdi mdi-lock mr-1"></i> Forgot your password?
                        </router-link>
                      </div>
                    </b-form>
                  </ValidationObserver>
                  <div class="mt-5 text-center">
                    <p>
                      Don't have an account ?
                      <router-link to="/register" class="font-weight-medium text-primary">
                        Signup now
                      </router-link>
                    </p>
                  </div>
                </div>
              </div>

              <div class="mt-4 mt-md-5 text-center">
                <p class="mb-0">
                  ©
                  {{ new Date().getFullYear() }}; Skote. Crafted with <i class="mdi mdi-heart text-danger"></i> by
                  Themesbrand
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import { login } from "@/store/api";
import { mapActions } from "vuex";
import { Carousel, Slide } from "vue-carousel";

export default {
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Carousel,
    Slide,
  },

  data() {
    return {
      credentials: {
        email: "",
        password: "",
      },
      errors: null,
    };
  },

  methods: {
    ...mapActions(["login"]),

    onLogin() {
      login(this.credentials)
        .then((response) => {
          this.login(response);
          this.$router.push("/");
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });
    },
  },
};
</script>
